import Home from "./Home";
import CaregiverTask from "./CaregiverTask";
import ManualCheckIn from "./ManualCheckin";
import QRCheckIn from "./QRCheckin";
import ResidentHome from "./ResidentHome";
import ResidentTask from "./ResidentTask";
import ResidentNotes from "./ResidentNotes";
import Notes from "./Notes";
import AddNotes from "./AddNotes";
import AllNotes from "./AllNotes";
import Vitals from "./Vitals";
import AddVitals from "./AddVitals";
import Community from "./Community";
import AdditionalRequest from "./AdditionalRequest";
import CaregiverProfile from "./CaregiverProfile";
import CaregiverResetPassword from "./CaregiverResetPassword";

export const caregiverRoutes = [
  { path: "/home", element: <Home /> },
  { path: "/select-community", element: <Community /> },
  { path: "/caregiver-task", element: <CaregiverTask /> },
  { path: "/checkin", element: <ManualCheckIn /> },
  { path: "/new-checkin", element: <QRCheckIn /> },
  { path: "/resident-home", element: <ResidentHome /> },
  { path: "/newResident", element: <ResidentHome /> },
  { path: "/resident-task", element: <ResidentTask /> },
  { path: "/resident-notes", element: <ResidentNotes /> },
  { path: "/notes", element: <Notes /> },
  { path: "/add-notes", element: <AddNotes /> },
  { path: "/all-notes", element: <AllNotes /> },
  { path: "/vitals", element: <Vitals /> },
  { path: "/addVitals", element: <AddVitals /> },
  { path: "/additionals", element: <AdditionalRequest /> },
  { path: "/caregiver-profile", element: <CaregiverProfile /> },
  { path: "/caregiver-reset-password", element: <CaregiverResetPassword /> },
];

export const CAREGIVER_ROUTE_PATHS = caregiverRoutes.map((route) => route.path);
